"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberOfBlogNr = exports.NumberOfBlog = void 0;
var NumberOfBlog;
(function (NumberOfBlog) {
    NumberOfBlog["three"] = "three";
    NumberOfBlog["five"] = "five";
    NumberOfBlog["eight"] = "eight";
    NumberOfBlog["nine"] = "nine";
    NumberOfBlog["all"] = "all";
})(NumberOfBlog = exports.NumberOfBlog || (exports.NumberOfBlog = {}));
var NumberOfBlogNr;
(function (NumberOfBlogNr) {
    NumberOfBlogNr[NumberOfBlogNr["three"] = 3] = "three";
    NumberOfBlogNr[NumberOfBlogNr["five"] = 5] = "five";
    NumberOfBlogNr[NumberOfBlogNr["eight"] = 8] = "eight";
    NumberOfBlogNr[NumberOfBlogNr["nine"] = 9] = "nine";
    NumberOfBlogNr[NumberOfBlogNr["all"] = -1] = "all";
})(NumberOfBlogNr = exports.NumberOfBlogNr || (exports.NumberOfBlogNr = {}));
